<template>
<div class="databases">
  <div class="databases__header">
    <h2>Databases <span>2 / 5</span></h2>
    <div>
      <el-button type="primary" icon="el-icon-plus">Database</el-button>
    </div>
  </div>
  <ul class="databases__list">
    <li class="databases__list--item" v-bind:key="database.index" v-for="database in databases">
      <database-item :database="database"></database-item>
    </li>
  </ul>
</div>
</template>
<script>
import DatabaseItem from './DatabaseItem';

export default {
  data: () => ({
    databases: [
      {
        index: 0,
        name: 'M123123123',
        note: 'Lorem ipsum',
        space: {
          available: 1024,
          used: 253,
        },
      },
      {
        index: 1,
        name: 'M34343434',
        note: 'Lorem ipsum',
        space: {
          available: 1024,
          used: 500,
        },
      },
    ],
  }),
  components: {
    'database-item': DatabaseItem,
  },
};
</script>
<style lang="scss">
.databases {
  position: absolute;
  top: 70px;
  right: 0;
  padding: 0 50px;
  width: calc(100% - 100px);

  &__header {
    width: 100%;
    margin: 10px 0 30px 0;
    border-bottom: 1px solid #aaaaaa;
    display: flex;
    justify-content: space-between;
    align-items: center;

      h2 {
        text-align: left;
        font-size: 24px;

        span {
          font-size: 16px;
          font-weight: 300;
        }
      }
  }

  &__list {
    list-style: none;
    padding: 0;

    &--item {
      position: relative;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Databases.vue